import { useState, useEffect } from "react";
import { Shirt, Clock, Car, Baby, Heart, AlertCircle, Star, Shield, Users, BookOpen, Smile, ThumbsUp } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICON_MAP = {
  Shirt: Shirt,
  Clock: Clock,
  Car: Car,
  Baby: Baby,
  Heart: Heart,
  AlertCircle: AlertCircle,
  Star: Star,
  Shield: Shield,
  Users: Users,
  BookOpen: BookOpen,
  Smile: Smile,
  ThumbsUp: ThumbsUp,
};

const WhatToExpect = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(`${API}/what-to-expect`);
        setItems(response.data);
      } catch {
        // Fallback defaults
        setItems([
          { icon: "Shirt", title: "What to Wear", content: "Comfortable clothes they can move in.", accent: "red" },
          { icon: "Clock", title: "Arrival Time", content: "Arrive 10 mins early for your first class.", accent: "blue" },
        ]);
      }
    };
    fetchItems();
  }, []);

  const getColor = (accent) => accent === "red" ? "#ff3131" : "#7dbff8";
  const getBg = (accent) => accent === "red" ? "bg-[#ff3131]/5" : "bg-[#7dbff8]/5";

  const renderIcon = (iconName) => {
    const IconComponent = ICON_MAP[iconName] || AlertCircle;
    return <IconComponent className="w-5 h-5" />;
  };

  if (items.length === 0) return null;

  return (
    <section className="py-16 md:py-20 bg-white" id="what-to-expect">
      <div className="container-gymtots">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D3436] mb-2" style={{ fontFamily: 'Fredoka, cursive' }}>
            What to Expect
          </h2>
          <p className="text-[#636E72] text-sm">Everything you need to know before your first class</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item, i) => (
            <div key={i} className="bg-[#FFFBF5] rounded-xl p-5 border border-gray-50" data-testid={`what-to-expect-item-${i}`}>
              <div className="flex items-start gap-3">
                <div 
                  className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${getBg(item.accent)}`}
                  style={{ color: getColor(item.accent) }}
                >
                  {renderIcon(item.icon)}
                </div>
                <div>
                  <h3 className="font-bold text-[#2D3436] text-sm mb-1" style={{ fontFamily: 'Fredoka, cursive' }}>
                    {item.title}
                  </h3>
                  <p className="text-xs text-[#636E72] leading-relaxed">{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;
